var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScopeUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77.33 77.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#282828;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.67,41.57c6.63,0,12.02-5.39,12.02-12.02s-5.39-12.02-12.02-12.02-12.02,5.39-12.02,12.02,5.39,12.02,12.02,12.02Zm0-21.53c5.24,0,9.5,4.26,9.5,9.5s-4.26,9.5-9.5,9.5-9.5-4.26-9.5-9.5,4.26-9.5,9.5-9.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.57,41.68l-.65-.2-.52,.44c-2.16,1.8-4.91,2.8-7.73,2.8s-5.56-.99-7.72-2.8l-.52-.44-.65,.2c-8.31,2.54-13.68,8.37-13.68,14.85v1.26H61.25v-1.26c0-6.49-5.37-12.32-13.68-14.85Zm-28.88,13.59c.65-4.69,4.88-8.88,11.19-10.98,2.52,1.9,5.62,2.94,8.79,2.94s6.27-1.04,8.79-2.94c6.31,2.11,10.54,6.29,11.19,10.98H18.69Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.67,.11C17.41,.11,.11,17.41,.11,38.67s17.29,38.55,38.55,38.55,38.55-17.29,38.55-38.55S59.92,.11,38.67,.11Zm0,74.58C18.8,74.7,2.63,58.54,2.63,38.67S18.8,2.63,38.67,2.63s36.03,16.16,36.03,36.03-16.16,36.03-36.03,36.03Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScopeUser);
export default __webpack_public_path__ + "static/media/scope_user.bd1012da83152c0418b90bb3e887e218.svg";
export { ForwardRef as ReactComponent };